<script type="text/javascript">
  // Houzeo site review
  export default {
    props: ['website'],
    data() {
      return {
        title: 'Houzeo',
        url: 'https://www.houzeo.com/flat-fee-mls/arizona',
        updated: '9/18/2023',

        pages: [
          // ========== START OF PAGE ==========
          {
            title: 'HOME',
            main: 1,
            url: `https://www.houzeo.com/flat-fee-mls/arizona`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Arizona Flat Fee MLS listing service, no hidden fees. Maximum exposure. List your local MLS to Zillow, Realtor.com, Trulia, and Redfin.`,
            meta_desc: `flat fee mls, flat fee mls arizona, flat fee realtor arizona, best flat fee mls arizona, arizona mls,northern arizona mls,mls listings arizona,mls phoenix az,mls prescott az,mls tucson az,mls listing chandler az`,
            h1: [
              `#1 Flat Fee MLS Service in Arizona`,
            ],
            h2: [
              `Plans designed with YOU in mind.`,
              `Houzeo vs. Other Top Flat Fee MLS Listing Services`,
              `See How Our Technology Makes FSBO Easy For You`,
              `General Arizona MLS information`,
              `Frequently Asked Questions`,
              `Houzeo in the news`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Products',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'IntelliList Listing Management',
                main: 1,
                url: `https://www.houzeo.com/products/intellilist-listing-management`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Houzeo Intellilist | Fastest Real Estate Listing Management`,
                meta_desc: `Houzeo's advanced user-friendly real estate listing management feature that enables home sellers to quickly list on the MLS and make changes on the go!`,
                h1: [
                  `IntelliList Listing Management`,
                ],
                h2: [
                  `IntelliList Listing Management is FREE For all Houzeo Home Sellers`,
                  `The fastest listing in the industry`,
                  `Request changes on the go`,
                  `Once you IntelliList, you won't list any other way`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Houzeo Showings',
                main: 1,
                url: `https://www.houzeo.com/products/houzeo-showings`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Houzeo Showings | Most Advanced Real Estate Showing Feature`,
                meta_desc: `Introducing the most advanced real estate showing feature ever! Sellers can now set up their showing calendar, accept showing proposals and release instructions on the go.`,
                h1: [
                  `Houzeo Showings`,
                ],
                h2: [
                  `Houzeo Showings is FREE For all GOLD and PLATINUM Sellers`,
                  `Buyers don't need an agent to request a showing`,
                  `Sellers control your own Showing Calendar`,
                  `It's also the most advanced Showing app in Real Estate`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Digital Transaction Management',
                main: 1,
                url: `https://www.houzeo.com/products/digital-transaction-management`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Houzeo DigiTransact | Digital Real Estate Transaction Management System`,
                meta_desc: `Houzeo's Seamless Digital Real Estate Transaction Management System helps you deal with multiple parties on a single platform such as a Title agent, notary, etc.`,
                h1: [
                  `Houzeo DigiTransact`,
                ],
                h2: [
                  `DigiTransact is in BETA Testing. It is FREE for all Houzeo Home Sellers`,
                  `Your team in one place`,
                  `Get ahead of the game`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Lead Management',
                main: 1,
                url: `https://www.houzeo.com/products/lead-management`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Houzeo's Lead Management | Methodical Lead Management System`,
                meta_desc: `Houzeo's methodical lead management system enables you to handle all your home buyer leads from various channels on a single platform. Get the best deal, now!`,
                h1: [
                  `Houzeo Lead Management`,
                ],
                h2: [
                  `Lead Management is FREE for all Houzeo Home Sellers`,
                  `Secure & powerful listing`,
                  `Stay in control of your info`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Houzeo Mobile App',
                main: 1,
                url: `https://www.houzeo.com/products/houzeo-mobile-app`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Houzeo Mobile App | Real Estate on the Move`,
                meta_desc: `With Houzeo's one-stop Mobile App manage real estate on the go! View your listing, manage showings and offers - all at your fingertips. Search for homes, set as favorites, and request showings.`,
                h1: [
                  `Houzeo Mobile App`,
                ],
                h2: [
                  `Manage Offers Like A Pro`,
                  `Manage Showings Like A Pro`,
                  `Find Your New Home`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Houzeo Offers',
                main: 1,
                url: `https://www.houzeo.com/products/houzeo-offers`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `View, compare, and manage offers on your home in real-time with Houzeo Offers! You can also Counter an offer, or request highest & best offers.`,
                meta_desc: `For sale by owner, Sell by owner, Sell my house, Sell my home, Real estate for sale by owner, Forsalebyowner.com, For sale by owner.com, Forsalebyowner, Flat fee MLS, Flat fee MLS listing, MLS listing, MLS listings, Discount Realtor, Discount Brokerage`,
                h1: [
                  `Houzeo Offers`,
                ],
                h2: [
                  `Houzeo Offers is FREE For all GOLD and PLATINUM Sellers`,
                  `Negotiate Offers Like A Pro!`,
                  `Single Offer? Counter it! Multiple? Highest & Best!`,
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'How Houzeo Works',
            main: 1,
            url: `https://www.houzeo.com/how-houzeo-works`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `How Houzeo Works | Comprehensive Videos for For Sale By Owner & Flat Fee MLS`,
            meta_desc: `Step-by-step instructional videos on How Houzeo Works and What is Houzeo.com. Check out the cutting edge technology on America's Most Advanced For Sale By Owner Platform`,
            h1: [
              ``,
              `What is Houzeo?`,
            ],
            h2: [
              `How to List Your Home & Request Changes 5:28 mins`,
              `Manage Showings 10:12 mins`,
              `Managing Offers 15:44 mins`,
              `Settlement Agent Selection 4:52 mins`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Reviews',
            main: 1,
            url: `https://www.houzeo.com/reviews`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Houzeo Reviews | Customer Reviews | 4.9 Stars ★ (5,450 reviews)`,
            meta_desc: `Houzeo reviews: Read reviews and testimonials from our happy customers, what they have to say about our services and website.`,
            h1: [
              `Houzeo Reviews & Testimonials`,
            ],
            h2: [
              `Overall Satisfaction Rating`,
              `Customer Videos`,
              `Customer Images`,
              `Customer Reviews`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Buy',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Homes For Sale',
                main: 1,
                url: `https://www.houzeo.com/homes-for-sale`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Homes For Sale By Owner | Flat Fee MLS Listings - Houzeo`,
                meta_desc: `The leading real estate marketplace. Search For Sale By Owner homes near you. Buy or sell with Houzeo`,
                h1: [
                  ``,
                  `Homes For Sale By Owner`,
                ],
                h2: [
                  `Popular Cities in`,
                  `Popular Counties in`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'For Sale By Owner Homes',
                main: 1,
                url: `https://www.houzeo.com/FOR-SALE-BY-OWNER`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `#1 Homes For Sale By Owner (FSBO) Websites - 9298 Homes | Real Estate | Houzeo`,
                meta_desc: `Search homes For Sale By Owner near me. Buy or sell homes with Houzeo. Make offers directly online and also get in touch with a seller to the perfect home.`,
                h1: [
                  ``,
                  `Homes For Sale By Owner`,
                ],
                h2: [
                  `Popular Cities in`,
                  `Popular Counties in`,
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'Sell',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Flat Fee MLS',
                main: 1,
                url: `https://www.houzeo.com/flat-fee-mls`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `America's #1 Flat Fee MLS Listing | 100% Online | Max Exposure`,
                meta_desc: `Save up to 6% on agent commission by choosing Houzeo’s Flat Fee MLS packages. #1 Multiple Listing Service in America for maximum savings and maximum exposure.`,
                h1: [
                  `America's Most Powerful MLS Listing Plans`,
                ],
                h2: [
                  `Plans designed with YOU in mind.`,
                  `Flat Fee MLS & For Sale By Owner Packages`,
                  `Houzeo vs. Other Top Flat Fee MLS Listing Services`,
                  `See How Our Technology Makes FSBO Easy For You`,
                  `General MLS information`,
                  `Frequently Asked Questions`,
                  `Houzeo in the news`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Reviews',
                main: 1,
                url: `https://www.houzeo.com/reviews`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Houzeo Reviews | Customer Reviews | 4.9 Stars ★ (5,450 reviews)`,
                meta_desc: `Houzeo reviews: Read reviews and testimonials from our happy customers, what they have to say about our services and website.`,
                h1: [
                  `Houzeo Reviews & Testimonials`,
                ],
                h2: [
                  `Overall Satisfaction Rating`,
                  `Customer Videos`,
                  `Customer Images`,
                  `Customer Reviews`,
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'Pricing',
            main: 1,
            url: `https://www.houzeo.com/pricing`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Flat Fee MLS | #1 For Sale By Owner (FSBO) Website`,
            meta_desc: `$349+ Flat Fee MLS Listing. List your home For Sale By Owner. 25 Photos. FSBO $0 Commission. Includes Zillow, Redfin, Realtor.com. FREE Cancellation`,
            h1: [
              `America's Most Powerful MLS Listing Plans`,
            ],
            h2: [
              `Plans designed with YOU in mind.`,
              `Flat Fee MLS & For Sale By Owner Packages`,
              `Houzeo vs. Other Top Flat Fee MLS Listing Services`,
              `See How Our Technology Makes FSBO Easy For You`,
              `Frequently Asked Questions`,
              `Houzeo in the news`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Resources',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Closing Cost Calculator',
                main: 1,
                url: `https://www.houzeo.com/closing-cost-calculator`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Closing Cost Calculator | Houzeo`,
                meta_desc: `Use our closing costs calculator to estimate buyer and seller closing costs, including doc stamps, intangible tax, and real estate commissions, etc. We use local tax and fee data to find you savings`,
                h1: [
                  `Houzeo's Advanced Closing Cost Calculator`,
                ],
                h2: [
                  `Seller Closing Cost Calculator`,
                  `Buyer Closing Cost Calculator`,
                  `Why Houzeo's Closing Costs Calculator Are So Advanced?`,
                  `What is Houzeo's Advanced Closing Costs Calculator?`,
                  `What are Closing Costs?`,
                  `What is a Closing Costs Calculator?`,
                  `How Much are the Closing Costs for a House?`,
                  `What are the Closing Costs for a House?`,
                  `Who Typically Pays Closing Costs?`,
                  `Seller Closing Costs – Detailed`,
                  `Buyer Closing Costs – Detailed`,
                  `Which Closing Costs Are Tax Deductible?`,
                  `How to Get Closing Costs Waived?`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Blog',
                main: 1,
                url: `https://www.houzeo.com/blog`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Houzeo Blog`,
                meta_desc: `America’s most advanced FSBO (For Sale by Owner) platform, Houzeo, provides tips and resources for selling or buying homes by owner.`,
                h1: [
                  `Recent Blogs`,
                ],
                h2: [
                  `How Much are Closing Costs for Buyers in Kansas?`,
                  `How Much are Closing Costs for Buyers in Indiana?`,
                  `How Much is Title Insurance in Washington D.C.?`,
                  `NMLS: A Complete Guide`,
                  `How Much is Title Insurance in West Virginia?`,
                  `What Is Fair Market Value of a House: A Complete Guide!`,
                  `How Much is Title Insurance in Kansas?`,
                  `What Percentage Do Realtors Make From a Home Sale?`,
                  `How to List on MLS For Sale By Owner in Florida (2023 Updates)`,
                  `How Much is Title Insurance in Florida?`,
                  `Posts navigation`,
                  `Save $20`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: `FAQ's`,
                main: 1,
                url: `https://www.houzeo.com/faq`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Comprehensive For Sale By Owner and Flat Fee MLS FAQs`,
                meta_desc: `Comprehensive FAQs to sell your home yourself and save $$$. Your Flat Fee MLS listing will be on all major real estate sites - MLS, Realtor.com, Zillow and Trulia`,
                h1: [
                  `Houzeo Frequently Asked Questions (FAQ)`,
                ],
                h2: [
                  ``,
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'Sign In',
            main: 1,
            url: `https://www.houzeo.com/login`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Login | Flat Fee MLS | Houzeo`,
            meta_desc: `Log in and list your house on the most advanced for sale by owner platform with Houzeo. In addition, by listing on Houzeo, you will get access to technologies only real estate agents have including flat fee MLS listings as well as access to closing agents.`,
            h1: [
              `Login`,
            ],
            h2: [
              `No hidden fees. No commission. No, really.`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Register',
            main: 1,
            url: `https://www.houzeo.com/register`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Register | Flat Fee MLS | Houzeo`,
            meta_desc: `Register on Houzeo and experience the most advanced FSBO platform. By listing on Houzeo, you will get access to technologies only real estate agents have including flat fee MLS listings as well as access to closing agents.`,
            h1: [
              `Create an Account`,
            ],
            h2: [
              `No hidden fees. No commission. No, really.`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Pros Near Me',
            main: 0,
            url: `https://www.houzeo.com/pros`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Find Local Real Estate Professionals Near Me | Houzeo`,
            meta_desc: `Find the right professionals for your real estate needs with Houzeo's Pro directory. Discover trusted and experienced title agents, escrow officers, and more near you. Start your search today!`,
            h1: [
              `Top Real Estate Professionals Near You`,
            ],
            h2: [
              `Vendor Directory`,
              `Top Real Estate Professionals Near You`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Affiliate Marketing',
            main: 0,
            url: `https://www.houzeo.com/affiliates`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Affiliate Marketing | Flat Fee MLS | Houzeo`,
            meta_desc: `Terms & Conditions | Flat Fee MLS | Pricing | Houzeo | The most advanced For Sale By Owner Website`,
            h1: [
              `Earn Big with Houzeo's Affiliate Program!`,
            ],
            h2: [
              `How Does it Work?`,
              `Why Partner with Houzeo?`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Terms and Conditions',
            main: 0,
            url: `https://www.houzeo.com/terms-conditions`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Terms And Conditions | Flat Fee MLS | Houzeo`,
            meta_desc: `Terms & Conditions | Flat Fee MLS | Pricing | Houzeo | The most advanced For Sale By Owner Website`,
            h1: [
              `Terms and Conditions`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Privacy Policy',
            main: 0,
            url: `https://www.houzeo.com/privacypolicy`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Privacy Policy | Selling Real Estate By Owner | Houzeo`,
            meta_desc: `Privacy Policy | Flat Fee MLS | Pricing | Houzeo | The most advanced For Sale By Owner Website`,
            h1: [
              `Privacy Policy`,
            ],
            h2: [
              `Advertising-Supported Business Model`,
              `Collection of Information`,
              `Usage and Disclosure`,
              `Email Management`,
              `Behavioral Advertising`,
              `Opting Out of Collection of Information by Third Parties`,
              `Location Data`,
              `Third-Party Websites`,
              `Children Under the Age of 13`,
              `Storage, Security and Retention of Information`,
              `Contacting Houzeo`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Refund and Cancellation Policy',
            main: 0,
            url: `https://www.houzeo.com/refund-policy`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `$99 Flat Fee MLS | Most Advanced For Sale By Owner (FSBO)`,
            meta_desc: `$99+ Flat Fee MLS Listing | List your home For Sale By Owner | 25 Photos | FSBO $0 Commission | Includes Zillow, Redfin, Realtor.com | FREE Cancellation`,
            h1: [
              `Refund Policy & Cancellation Policy`,
            ],
            h2: [
              ``,
            ]
          },

        ],

      }
    },
    computed: {
      compPages: function() {
        var output = [];
        for(var i in this.pages) {
          var temp = JSON.parse(JSON.stringify(this.pages[i]));
          if(temp['children']) { delete temp['children']; }
          output.push(temp);
          if(this.pages[i]['children']) {
            for(var j in this.pages[i]['children']) {
              var temp = JSON.parse(JSON.stringify(this.pages[i]['children'][j]));
              if(temp['children']) { delete temp['children']; }
              output.push(temp);
            }
          }
        }
        return output;
      },
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="0"
    ></w-site-navbar>
    <main>

      <section class="bg-home pb-5">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-15 pb-10 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="home-title mb-3 text-white" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-white home-desc"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a href="/selling" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init">I'm selling</a></div>
                    <div class="col-sm px-sm-1"><a href="/buying" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                    <div class="col-sm px-sm-1"><a href="/valuation" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} navigation</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s navigation menu, sub menu's and additional pages.</p>
          </div>

          <div class="border font-weight-bold rounded bg-lighten-success small p-5">
            <h4 class="_underline">Site info</h4>
            <div class="mb-5">
              <div class=""><strong>Company :</strong> {{title}}</div>
              <div class=""><strong>URL :</strong> {{url}}</div>
              <div class=""><strong>Last updated :</strong> {{updated}}</div>

            </div>
            <h4 class="_underline">Main navigation</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="item['main']">
                <div class="font-weight-bolder">{{item['title']}}</div>
                <ul class="pl-5 m-0">
                  <li v-for="(sub1, sub1_i) in item['children']" :key="sub1_i">
                    {{sub1['title']}}
                    <ul class="pl-5 m-0">
                      <li v-for="(sub2, sub2_i) in sub1['children']" :key="sub2_i">
                        {{sub2['title']}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

            </ul>
            <h4 class="mt-5 _underline">Additional pages</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="!item['main']">{{item['title']}}</li>
            </ul>
          </div>



        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} page content</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s website content and SEO basics. Scroll through the table vertically and horizontally with the mouse wheel.</p>
          </div>

          <div class="table-responsive">
            <table class="table table-small table-bordered-right table-hover mb-0 text-nowrap border border-light">
              <thead class="bg-lighten-success">
                <tr>
                  <th class="font-weight-bold">Menu item</th>
                  <th class="font-weight-bold">URL</th>
                  <th class="font-weight-bold">Positives</th>
                  <th class="font-weight-bold">Negatives</th>
                  <th class="font-weight-bold">Meta title</th>
                  <th class="font-weight-bold">Meta description</th>
                  <th class="font-weight-bold">H1's</th>
                  <th class="font-weight-bold">H2's</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_i) in compPages" :key="item_i">
                  <td class="bg-light font-weight-bold">{{item['title']}}</td>
                  <td>{{item['url']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['positives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['negatives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>{{item['meta_title']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">{{item['meta_desc']}}</td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h1']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h2']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
